/**
 * 业务上层布局组件
 */
// eslint-disable-next-line no-use-before-define
import React, {useEffect, useRef, useState} from 'react';
import Routers from 'src/router/router';
import Menu from 'src/components/menu';
import { connect } from 'react-redux';
import HeaderDom from 'src/components/header';
import MenuTabs from 'src/components/menu/menuTabs';
import News from 'src/components/header/news';
import { Layout, notification } from 'antd';
import Scoket from 'src/utils/websocket';
import bus from 'src/utils/eventBus';
import { useInterval } from 'react-use';
import TerminalInfo, { CRef as TRef, KeyType } from 'src/components/business/terminalInfo';
import {user} from 'src/api/index';
import { LangMessage } from 'src/store/common/language';
import { destoryCache } from 'src/components/react-keepalive-router/index.jsx';
import { CONNECT_STATE } from 'src/store/common/wsState';
import moment from 'moment';
import { SET_DEFAULT_TIME } from 'src/store/common/serverTime';
const { Header, Content } = Layout;

type Cache = {
    username: string;
    wsState: boolean;
    // timer: NodeJS.Timeout | null;
    time: string;
}

type OpenDeviceParams = {
    type: 'dcu' | 'meter',
    id: string;
    keyType?: KeyType;
}

type Props = {
    webSocketInfo: string;
    Mes: LangMessage;
    username: string;
    dispatch: React.Dispatch<any>;
    wsState: boolean;
    serverTime: string;
}


const Main = (props: Props) => {
    const { webSocketInfo, username, dispatch, wsState, Mes, serverTime } = props;
    const FORMAT = 'YYYY-MM-DD HH:mm:ss';
    const cache = useRef<Cache>({
        username: username,
        wsState: wsState,
        // timer: null,
        time: '',
    });
    const tRef = useRef<TRef>();
    const [ isStart, setStart ] = useState<boolean>(false);

    useInterval(() => {
        user.keepLogin();
    }, 90000);
    useEffect(() => {
        cache.current.wsState = wsState;
    }, [ wsState ]);

    const updateServerTime = () => {
        // console.info('updateServerTime', serverTime);
        if (serverTime) {
            if (!cache.current.time) {
                cache.current.time = serverTime;
            }
            const now = moment(cache.current.time, FORMAT);
            let next = now.add(1, 'seconds').format(FORMAT);

            cache.current.time = next;
            // console.info('next time:', next, moment(new Date()).format(FORMAT));
            dispatch({
                type: SET_DEFAULT_TIME,
                value: {
                    serverTime: next,
                },
            });
        } else {
            // if (cache.current.timer) {
            //     clearInterval(cache.current.timer);
            //     cache.current.timer = null;
            // }
            setStart(false);
        }
    };

    useInterval(() => {
        updateServerTime();
    }, isStart ? 1000 : null);

    const getServerTime = async () => {
        // if (cache.current.timer) {
        //     clearInterval(cache.current.timer);
        //     cache.current.timer = null;
        // }
        setStart(false);
        if (window.document.visibilityState === 'visible') {
            // cache.current.time = moment(new Date()).format(FORMAT);
            const res = await user.getUserSessionContent();

            cache.current.time = res.serverDateTime;
            console.info('getServerTime', 'create interval');
            // cache.current.timer = setInterval(updateServerTime, 1000);
            setStart(true);
            dispatch({
                type: SET_DEFAULT_TIME,
                value: {
                    serverTime: cache.current.time,
                    timeZone: res.timeZoneId,
                },
            });
        }
    };

    const refreshServerTime = async () => {
        // if (cache.current.timer) {
        //     clearInterval(cache.current.timer);
        //     cache.current.timer = null;
        // }
        setStart(false);
        const res = await user.getUserSessionContent();

        cache.current.time = res.serverDateTime;
        console.info('refreshServerTime', 'create interval');
        // cache.current.timer = setInterval(updateServerTime, 1000);
        setStart(true);
        dispatch({
            type: SET_DEFAULT_TIME,
            value: {
                serverTime: cache.current.time,
                timeZone: res.timeZoneId,
            },
        });
    };

    // webscoket发送消息
    useEffect(() => {
        if (!username) {
            destoryCache();
        }
        cache.current.username = username;
    }, [ username ]);

    useEffect(() => {
        const ws = new Scoket({
            url: webSocketInfo,
            params: {
                username: username,
            },
        });

        if (window.config.project === 'MDR') {
            ws.connection();
            refreshServerTime();
        }
        bus.on('sendMsg', async (data) => {
            ws.sendMessage(data);
        });
        bus.on('openDevice', async ({ type, id, keyType = 'dcuGuid' }: OpenDeviceParams) => {
            tRef.current?.openModel(type, id, keyType);
        });
        bus.on('connection', async () => {
            ws.connection();
        });
        bus.on('error', async (vals:any) => {
            if (cache.current.wsState) {
                dispatch({
                    type: CONNECT_STATE,
                    value: false,
                });
            }
            if (vals) {
                notification.error({
                    message: Mes['messageHintErrorerror'],
                    description: Mes['mainDialogWebsoketfailwebsoketfail'],
                    duration: 2,
                });

            }
        });
        bus.on('onOpen', async (vals: any) => {
            if (!cache.current.wsState) {
                dispatch({
                    type: CONNECT_STATE,
                    value: true,
                });
            }
            if (vals && typeof vals === 'boolean') {
                notification.success({
                    message: Mes['messageTitleWebsocketSuccessful'],
                    duration: 2,
                });
            }
        });
        window.addEventListener('visibilitychange', getServerTime);
        return () => {
            // if (cache.current.timer) {
            //     clearInterval(cache.current.timer);
            //     cache.current.timer = null;
            // }
            setStart(false);
            ws.loginOut();
            console.info('remove visibilitychange');
            window.removeEventListener('visibilitychange', getServerTime);
            // window.removeEventListener('beforeunload', refreshServerTime);
            bus.removeAllListeners('sendMsg');
            bus.removeAllListeners('error');
            bus.removeAllListeners('onOpen');
            bus.removeAllListeners('openDevice');
            bus.removeAllListeners('connection');
        };
    }, []);

    return (
        <>
            <Layout className='home'>
                {/* 菜单 */}
                <Menu />
                <Layout className='container'>
                    {/* 头部 */}
                    <>
                        <Header className='header'></Header>
                        <HeaderDom />
                    </>

                    {/* 主要业务模块 */}
                    <Content className='content'>
                        <Routers />
                    </Content>
                    {/* 菜单标签 */}
                    <MenuTabs />
                    {/* 消息 */}
                    <News />
                    <span className='copyright'>{Mes['labelTitleCopyright']}</span>
                </Layout>
            </Layout>
            <TerminalInfo cRef={tRef} />
        </>
    );
};

export default connect((state: any) => ({
    webSocketInfo: state.userInfo?.webSocketInfo,
    Mes: state.langSwitch?.message,
    username: state.userInfo.sysUser.username,
    wsState: state.connectWs.wsState,
    serverTime: state.defaultTime.serverTime,
}))(Main);
